export default __webpack_public_path__ + "static/media/grandpa_in_fog.a71ac435.jpg";